import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
  MatSnackBarModule,
  MAT_SNACK_BAR_DEFAULT_OPTIONS,
} from '@angular/material/snack-bar';
import { ToastService } from './toast.service';

@NgModule({
  declarations: [],
  imports: [CommonModule, MatSnackBarModule],
  exports: [],
  providers: [
    {
      provide: MAT_SNACK_BAR_DEFAULT_OPTIONS,
      useValue: {
        duration: 2500,
        verticalPosition: 'top',
      },
    },
    ToastService,
  ],
})
export class ToastModule {}
